// extracted by mini-css-extract-plugin
export default {"logowrapper":"styles_logowrapper__gXRNo"};